module.exports = __webpack_public_path__ + "img/jam_twitter-circle.9ed436ae.svg";